import script from "./ExampleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ExampleComponent.vue?vue&type=script&setup=true&lang=js"

import "./ExampleComponent.vue?vue&type=style&index=0&id=d1fa1a52&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1fa1a52"]])

export default __exports__